export default "__VITE_ASSET__B$wO26gh__"